<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <div class="tips">
            <div class="tip-box" v-for="item in level" :key="item.color">
                <div class="color" :style="{background: item.color}"></div>
                <div class="text" v-if="item.max">≤{{item.max}}</div>
                <div class="text" v-else>>{{item.min}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import JSON from '../../assets/home/yunnan.json';

    export default {
        name: 'MapCharts',
        props: {
            'list': Array,
            'level': Array
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove',
                        formatter: params => {
                            return `${params.data.name}  ${params.data.value}`;
                        }
                    },
                    visualMap: {
                        show: false,
                        pieces: [],
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    series: [{
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        data: []
                    }]
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        methods: {
            getSeriesData () {
                // 填入省份及数据
                if (this.list.length > 0) {
                    return this.list.map(item => {
                        return {
                            name: item.name,
                            value: item.value
                        };
                    });
                } else {
                    return JSON.features.map(item => {
                        return {
                            name: item.properties.name,
                            value: Math.ceil(Math.random() * 100)
                        };
                    });
                }
            },
            getColor () {
                // 填入颜色及范围
                if (this.level.length > 0) {
                    return this.level.map(item => {
                        return {
                            min: item.min,
                            max: item.max,
                            color: item.color
                        };
                    });
                }
            },
            setSeriesData () {
                this.setOptions('series', (() => {
                    return {
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        data: this.getSeriesData()
                    }
                })());
                this.setOptions('visualMap', (() => {
                    return {
                        show: false,
                        pieces: this.getColor(),
                        textStyle: {
                            color: '#fff'
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }

    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
    .tips{
        display: flex;
        margin-top: 30px;
        justify-content: space-around;
        align-items: center;
        .tip-box{
            display: flex;
            align-items: center;
            .color{
                width:14px;
                height:14px;
            }
            .text{
                font-size:20px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                margin-left: 8px;
            }
        }
    }
}
</style>
